"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework base class for PartForm controls
         * @internal
         * @description PartForm lifecycle:
         * - InitPartForm
         * - Wait for Root ReadyState
         * - ShouldCreatePartForm
         * - IsFirstChild
         * - CreatePartForm
         */
        var PartForm = /** @class */ (function (_super) {
            __extends(PartForm, _super);
            function PartForm(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.Width = $dyn.layout.Size.available;
                _this.Height = $dyn.layout.Size.available;
                var part = data.Part;
                _this.Part = $dyn.observable(part);
                // get the host root for the form part
                _this.hostForm = $dyn.context($(element).parents(".active-form")[0]);
                if (!part) {
                    part = {};
                }
                $dyn.callFunction(part.InitPartForm, part, element);
                // Use 2 at the end of variable name to not override the form one
                _this.readyStatePromise2 = $dyn.deferred.onTrue(function () {
                    return !part.Root || (part.Root && $dyn.value(part.Root.ReadyState) === $dyn.ui.ReadyState.ready && !$dyn.clientBusy()) || $dyn.value(part.LoadInline);
                });
                _this.readyStatePromise2.done(function () {
                    if ($dyn.callFunction(part.ShouldCreatePartForm, part, { element: element, partForm: _this }) === false) {
                        // Only return if we strictly return false. If the function is not defined, that is ok.
                        return;
                    }
                    if ($dyn.value(part.IsFirstChild) === true && !$dyn.value(part.Expanded) && $dyn.value(part.Expand)) {
                        // If this is the first factbox expand the factbox initially
                        $dyn.async(function () {
                            $dyn.callFunction(part.SystemExpand, part, [true]);
                        }, undefined, "Expand first factbox");
                    }
                    if ($dyn.value(part.RunMode) === "Local" && $dyn.value(part.CreateForm)) {
                        $dyn.callFunction(part.CreatePartForm, part, { mode: "Local", element: element, partForm: _this });
                    }
                    else {
                        $dyn.observe(function () {
                            var isDataBound = $dyn.value(part.IsDataBound);
                            var runMode = $dyn.value(part.RunMode);
                            var partHostViewConfiguration = "";
                            if (part.Root) {
                                var param = { HostViewKey: $dyn.value(part.Root.CurrentViewKey), PersonalizationViewsSaveModel: $dyn.value(part.Root.PersonalizationViewsSaveModel) };
                                partHostViewConfiguration = JSON.stringify(param);
                            }
                            if (isDataBound && !_this.inited) {
                                _this.inited = true;
                                var children_1 = part.Children();
                                var resource = {
                                    menuItem: $dyn.value(part.ObjectName),
                                    PartHostViewConfiguration: partHostViewConfiguration,
                                };
                                if (runMode !== "Local") {
                                    var dataFilter = {
                                        FormPartType: part.TypeName,
                                        LinkedId: part.Name,
                                        Ranges: [],
                                    };
                                    resource.DataFilter = dataFilter;
                                    if (children_1) {
                                        for (var i = 0, len = children_1.length; i < len; i++) {
                                            var child = children_1[i];
                                            dataFilter.Ranges.push({
                                                DataField: $dyn.value(child.TargetFieldName),
                                                DataSource: $dyn.value(child.TargetModelName),
                                                LinkedId: child.Name,
                                                Value: $dyn.value(child.LinkedValue),
                                            });
                                        }
                                    }
                                }
                                return resource;
                            }
                        }, function (resource) {
                            if (resource) {
                                // formPart could be renamed to be reflect the channel the form runs under.
                                resource.formPart = $dyn.value(part.RunMode) !== "Local";
                                resource.targetElement = element;
                                resource.callback = _this.PartFormCreated.bind(_this);
                                resource.ShouldBlockOnExecution = false;
                                $dyn.log.form && $dyn.log.form("Form: loading form: %s with resource: %o", resource.menuItem, resource);
                                $dyn.callFunction(part.CreatePartForm, part, { mode: "Remote", resource: resource });
                            }
                        });
                    }
                });
                // Return the IsActive state of the Part's containing form.
                _this.isRootFormActive = $dyn.computed(function () {
                    return $dyn.value(_this.Part().Root.IsActive);
                });
                // Override the form's _close logic which is to clean up the DOM representation of the form.
                // Since PartForm's are nested inside the DOM of the host form, this code should just no op.
                _this._close = function () {
                    $dyn.log.form && $dyn.log.form("Form: _close called on Part form %s", _this.Name);
                    _this._clearRefreshInterval();
                };
                return _this;
            }
            Object.defineProperty(PartForm.prototype, "TakeFocus", {
                get: function () {
                    // See the base definition for documentation.
                    var shouldTakeFocus = true;
                    // The PartForm doesn't have Root set. Instead, grab the Root from the containing Part.
                    var partObj = this.Part();
                    if (this._takeFocus === false) {
                        shouldTakeFocus = false;
                    }
                    else if (partObj && partObj.Root && partObj.Root !== this && partObj.Root.TakeFocus !== undefined) {
                        shouldTakeFocus = partObj.Root.TakeFocus;
                    }
                    return shouldTakeFocus;
                },
                set: function (value) {
                    // See the base definition for documentation.
                    this._takeFocus = $dyn.peek(value);
                },
                enumerable: false,
                configurable: true
            });
            PartForm.prototype.Open = function () {
                // Use the visible handler here so that the parent of the part gets an arrange called on it when it changes visibility.
                $dyn.util.setVisibility(this.element, true, false);
                this.IsOpen(true);
            };
            /**
             * Captures the focusIn for the part form and calls activate on its parent, i.e. Part to be set as the active control on the parent form.
             * @description The active control in the part form also needs to be tracked, hence InternalFocusIn is called.
             * @internal
             * @param evt Event object
             */
            PartForm.prototype.FocusIn = function (evt) {
                $dyn.log.focus && $dyn.log.focus("Focus: Part Form(Form.Id: %s)->FocusIn", this.element.getAttribute("data-dyn-form-name"));
                // stop the focus event if we can not focus
                if (!$dyn.shell.canFocus(this)) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->FocusIn invalid focus attempt", this.Id);
                    evt.stopImmediatePropagation();
                    evt.preventDefault();
                    return;
                }
                var lastActiveElement = this.ActiveElement();
                var activeElement = evt.target;
                activeElement = $(activeElement).addBack().closest("[data-dyn-controlname]")[0];
                // only act on the focus event if it's for an element belonging to this part form
                // Activate the part if it is for this part form.
                if (!$dyn.context(activeElement) || !$dyn.context(activeElement).Root || this.Id === $dyn.context(activeElement).Root.Id) {
                    this.focusedControl = activeElement;
                    this.InternalFocusIn(activeElement, lastActiveElement);
                    this.Part().activate();
                }
            };
            PartForm.prototype.isFormActive = function () {
                var myPart = this.Part();
                var root = this.Part().Root;
                // root could be absent in case of company picker which is implemented as a partform but does not have a root form.
                // It has its own focus handling mechanism.
                if (root === undefined) {
                    root = this;
                }
                var rootActiveControl = $dyn.value(root.ActiveControl);
                if (myPart.Name === rootActiveControl && root.isNavigationActiveForm() === true && $dyn.value(this.IsOpen)) {
                    return true;
                }
                return false;
            };
            PartForm.prototype.PartFormCreated = function () {
                var part = $dyn.value(this.Part);
                // Have the Part Control read the created Part Form's ID
                part.readFormId();
                // Set the Part Controls' PartForm to this now that it's loaded.
                part.PartForm = this;
                if (!part.Root || part.Name === $dyn.value(part.Root.ActiveControl)) {
                    this.takeNavigationFocus();
                }
                this._initiateAutoRefresh();
                var hostForm = part.Root;
                if (hostForm) {
                    hostForm.RegisterFormPart(this);
                }
                // Trigger the partCreated event if the part was loaded after the rest of the form.
                if ($dyn.value(part.LoadInline) !== true) {
                    $(document.body).trigger($dyn.forms.Events.partCreated, [this]);
                }
            };
            // Override the Form's ObserveFactBoxes since those do not apply to this sub form type
            PartForm.prototype.ObserveFactBoxes = function () { };
            PartForm.prototype.dispose = function () {
                this._clearRefreshInterval();
                if (this.readyStatePromise2 && this.readyStatePromise2.reject) {
                    this.readyStatePromise2.reject();
                }
                if (this.hostForm) {
                    this.hostForm = undefined;
                }
                _super.prototype.dispose.call(this);
            };
            PartForm.prototype.keydown = function (event) {
                $dyn.util.handleShortcuts(this, event);
                // Let the parent form handle the event if it has not been handled by the form part
                if (!event.isPropagationStopped()) {
                    if (this.Part().Root) {
                        $dyn.util.handleShortcuts(this.Part().Root, event);
                    }
                }
            };
            PartForm.prototype._initiateAutoRefresh = function () {
                var _this = this;
                var part = $dyn.value(this.Part);
                // Set up Auto Refresh if it exists
                var refreshInterval = $dyn.value(part.RefreshInterval);
                if (refreshInterval > 0) {
                    // Convert interval to milliseconds
                    var interval = refreshInterval * 1000;
                    var autoRefreshPart = function () {
                        if ($(_this.element).is(":visible")) {
                            _this.executeShortcuts(false, "Refresh");
                        }
                    };
                    this._refreshIntervalId = window.setInterval(autoRefreshPart, interval);
                }
            };
            PartForm.prototype._clearRefreshInterval = function () {
                if (this._refreshIntervalId) {
                    clearInterval(this._refreshIntervalId);
                    this._refreshIntervalId = undefined;
                }
            };
            return PartForm;
        }($dyn.controls.Form));
        controls.PartForm = PartForm;
        // Part forms should take part in their host form's tab order thus they are not individual tab containers.
        PartForm.prototype.IsTabbingContainer = false;
        // tslint:disable:object-literal-sort-keys
        var PartFormShortcuts = {
            AdvancedFilterSort: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.f3 },
                Handler: function (evt) {
                    this.executeShortcuts(true, "AdvancedFilterSort", evt);
                },
                Description: $dyn.label("Form_OpenAdvancedSort"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            AltSave: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterS },
                Handler: function (evt) {
                    this.executeShortcuts(true, "SaveRecord", evt);
                },
                Description: $dyn.label("Form_SaveRecord"),
                Category: $dyn.ui.ShortcutCategory.ActOnData,
            },
            Attach: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterA },
                Handler: function (evt) {
                    this.executeShortcuts(true, "AttachRecord", evt);
                },
                Description: $dyn.label("Form_AttachDocument"),
            },
            Delete: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.deleteKey },
                Handler: function (evt) {
                    this.executeShortcuts(false, "DeleteRecord", evt);
                },
                Description: $dyn.label("Form_DeleteRecord"),
                Category: $dyn.ui.ShortcutCategory.ActOnData,
            },
            DeleteF9: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.f9 },
                Handler: function (evt) {
                    this.executeShortcuts(false, "DeleteRecord", evt);
                },
                ShowToUser: false,
            },
            ExportToExcel: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterE },
                Handler: function (evt) {
                    this.executeShortcuts(true, "ExportToExcel", evt);
                },
                Description: $dyn.label("Form_ExportExcel"),
            },
            FirstRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.home },
                Handler: function (evt) {
                    this.executeShortcuts(true, "FirstRecord", evt);
                },
                Description: $dyn.label("Form_FirstRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            LastRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.end },
                Handler: function (evt) {
                    this.executeShortcuts(true, "LastRecord", evt);
                },
                Description: $dyn.label("Form_LastRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            NextRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function (evt) {
                    this.executeShortcuts(true, "NextRecord", evt);
                },
                Description: $dyn.label("Form_NextRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            PreviousRecord: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function (evt) {
                    this.executeShortcuts(true, "PreviousRecord", evt);
                },
                Description: $dyn.label("Form_PrevRecord"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            Save: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.letterS },
                Handler: function (evt) {
                    this.executeShortcuts(true, "SaveRecord", evt);
                },
                ShowToUser: false,
            },
        };
        // NOTE: This does not extend the prototype as the shortcuts defined on Form need to go to the host form
        PartForm.prototype.Shortcuts = PartFormShortcuts;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PartForm.js.map
